import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import HeaderLoggedOut from '../components/HeaderLoggedOut';
import ThankyouImage from '../assets/images/thankyou.jpg';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 10,
    marginTop: theme.spacing.unit * 2,
    height: '87.8vh',
  }),
  wrapper: {
    backgroundColor: '#f1f7e9',
    height: '100vh',
    textAlign: 'center',
  },
  image: {
    maxWidth: 1250,
    height: 517,
    margin: 'auto',
    background: `url(${ThankyouImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
  button: {
    width: 'auto',
    background: '#ff9800',
    color: 'white',
    fontSize: '16px',
    fontWeight: 900,
    letterSpacing: '2px',
  },
  link: {
    textDecoration: 'none',
    color: '#ff9800',
  },
});

class ThankyouPage extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapper}>
        <HeaderLoggedOut signup={true} />
        <Grid container>
          <Grid item xs={12}>
            <Paper className={classes.root} elevation={4}>
              <h1>You have successfully signed up!</h1>
              <h2>Your account details have been sent to your email.</h2>
              <div className={classes.image} />
              <Link to="/signin" className={classes.link}>
                <Button className={classes.button}>SIGN IN</Button>
              </Link>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(ThankyouPage));



// WEBPACK FOOTER //
// ./src/containers/ThankyouPage.js